export const isMac = (navigator.userAgent ?? navigator.platform ?? '').toLowerCase().includes('mac');
